var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{style:(_vm.formattedStyle)},[_c('label',{class:_vm.getClass,attrs:{"title":_vm.title},on:{"click":_vm.onFill}},[(_vm.applyCurrencyFormat)?_c('div',[_vm._v(_vm._s(_vm._f("currency")(_vm.fillableValue)))]):(_vm.applyDateFormat)?_c('div',[_vm._v(_vm._s(_vm.formattedDateValue))]):_c('div',[_vm._v(_vm._s(_vm.fillableValue))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }